export default __webpack_public_path__ + "static/media/WAS0120.34I-35522_-20670_0.247c54e6.jpg";